<template>
  <div :class="{
    'calendar-item': true,
    'is-grid': layout === 'grid',
    'is-list': layout === 'list',
    'is-expanded': isExpanded && layout === 'list',
    'user-cannot-add': !userCanAddReservation && !hasReservations
  }">
    <div
      :class="{
        'calendar-item-wrapper': true,
        'has-reservations': hasNewReservations,
        'has-blocked-dates': hasBlockedDates,
        'no-reservations': !hasNewReservations && !hasBlockedDates && !itemData.ongoing_reservations.length,
        'has-ongoing-reservations': itemData.ongoing_reservations.length && !hasNewReservations
      }"
      @click="!hasReservations && userCanAddReservation ? addReservation() : false">
      <hour
        v-if="layout === 'list'"
        :value="itemData.time"
        :hasBorder="true"
        :hasPadding="true"
        :hasServiceColor="true"
        :serviceColor="itemData.reservations && itemData.reservations.length === 1 && itemData.reservations[0].service ? itemData.reservations[0].service.color : ''"
        @click.native="userCanAddReservation ? addReservation() : false" />

      <div
        v-if="hasReservations && layout === 'list'"
        class="calendar-item-reservations"
        @click="userCanAddReservation ? addReservation() : false">
        <item-counter
          v-if="peopleNumberEnabled && (itemData.people_number || itemData.blocked_dates_number)"
          class="people-number"
          icon="profile-big"
          :value="itemData.people_number"
          text=""
          :title="$t('common.ui.peopleNumber') + ': ' + itemData.people_number"></item-counter>

        <item-counter
          v-if="itemData.reservations_number"
          class="reservations-number"
          icon="check-circle"
          :value="itemData.reservations_number"
          text=""
          :title="$t('common.ui.reservationsNumber') + ': ' + itemData.reservations_number"></item-counter>

        <item-counter
          v-if="itemData.blocked_dates_number"
          class="blocked-dates-number"
          icon="lock"
          :value="itemData.blocked_dates_number"
          text=""
          :title="$t('common.ui.blockedDatesNumber') + ': ' + itemData.blocked_dates_number"></item-counter>

        <span
          v-if="itemData.ongoing_reservations.length"
          class="ongoing-reservations"
          @click.stop="$bus.$emit('show-calendar-day-popup-ongoing-reservations', itemData.time, itemData.ongoing_reservations)">
          {{ itemData.ongoing_reservations.length }} {{ $t('common.ui.ongoing') }} <template v-if="peopleNumberEnabled">({{ ongoingReservationsPeopleNumber(itemData.ongoing_reservations) }}os.)</template>
          <icon
            name="info-circle-alt"
            primaryColor="color-text-light"
            strokeColor="color-text-light"
            size="xxs" />
        </span>

        <span
          v-if="itemData.ongoing_reservations.length && !itemData.reservations_number && !itemData.blocked_dates_number"
          class="add-reservation"
          @click.stop="userCanAddReservation ? addReservation() : false">
          +
        </span>
      </div>

      <btn
        v-if="(hasNewReservations || hasBlockedDates) && layout === 'list'"
        type="medium icon"
        iconName="arrow-down"
        iconColor="color-text-light"
        iconSize="xxs"
        @click.stop.native="toggleOngoingReservations()" />
    </div>

    <div
      v-if="hasReservations"
      class="calendar-item-content">
      <reservation
        v-for="(reservationData, index) of itemData.reservations"
        :key="'reservation-' + index"
        :inCalendar="true"
        :isReservation="true"
        :showWorker="$parent.$parent.currentTab === 'upcoming'"
        :reservationData="reservationData" />

      <btn
        v-if="layout === 'list' && userCanAddReservation"
        type="success full-width"
        @click.native="addReservation()">
        {{ $t('common.ui.addReservation') }}
      </btn>

      <a
        v-if="layout === 'list'"
        href="#"
        class="toggle-details"
        @click.stop.prevent="toggleOngoingReservations()">
        {{ $t('common.ui.hideDetails') }}
      </a>
    </div>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import Hour from './../common/Hour';
import ItemCounter from './../common/ItemCounter';
import Reservation from './../ui/Reservation';
import UserTypes from './../mixins/UserTypes';

export default {
  name: 'calendar-item',
  mixins: [
    Configuration,
    UserTypes
  ],
  props: [
    'itemData',
    'layout',
    'date',
    'workerID'
  ],
  data () {
    return {
      isExpanded: this.layout === 'grid'
    };
  },
  components: {
    'hour': Hour,
    'item-counter': ItemCounter,
    'reservation': Reservation
  },
  computed: {
    hasReservations () {
      return this.itemData.people_number || this.itemData.reservations_number || this.itemData.blocked_dates_number || this.itemData.ongoing_reservations.length;
    },
    hasBlockedDates () {
      return this.itemData.blocked_dates_number > 0;
    },
    hasNewReservations () {
      return this.itemData.people_number || this.itemData.reservations_number;
    }
  },
  mounted () {
    this.$bus.$on('calendar-item-set-expand-state', this.setExpandState);
  },
  methods: {
    ongoingReservationsPeopleNumber (reservations) {
      return reservations.map(reservation => reservation.people_number).reduce((a, b) => a + b, 0);
    },
    addReservation () {
      if (!this.userCanAddReservation) {
        return;
      }

      let nextUrl = '/reservation/new/date/' + this.date + '/' + this.itemData.time;

      if (this.workerID) {
        nextUrl = '/reservation/new/date/' + this.date + '/' + this.itemData.time + '/' + this.workerID;
      }

      this.$bus.$emit('confirm-display', {
        title: this.$t('common.ui.addingReservation'),
        desc: this.$t('calendar.other.youWantToAddReservation', { date: this.date, time: this.itemData.time }),
        cancelLabel: this.$t('common.ui.cancel'),
        cancelClick: () => false,
        okLabel: this.$t('common.ui.addReservation'),
        okClick: () => this.$router.push(nextUrl),
        isDanger: false
      });
    },
    toggleOngoingReservations () {
      this.isExpanded = !this.isExpanded;
    },
    setExpandState (newState) {
      if (this.hasNewReservations || this.hasBlockedDates) {
        this.isExpanded = newState;
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('calendar-item-set-expand-state', this.setExpandState);
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.calendar-item {
  border-bottom: 1px solid $color-border-light;
  cursor: pointer;
  padding: 1rem 0;

  &:first-child {
    border-top: 1px solid $color-border-light;
  }

  &-wrapper {
    display: flex;
    min-height: 32px;

    &.no-reservations {
      background: linear-gradient($color-button-default-top, $color-button-default-bottom);
      border: 1px solid $color-button-default-border;
      border-radius: $border-radius-small;
      padding: .35rem 0;
      position: relative;

      &:after {
        content: "+";
        position: absolute;
        right: 1.35rem;
        top: 50%;
        transform: translateY(-50%);
      }

      .hour-value {
        line-height: 1.15;
        margin-left: -1px;
      }

      .add-reservation {
        position: absolute;
        right: 1.35rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }
    }

    &.has-ongoing-reservations {
      background: linear-gradient(lighten($color-warning, 44%), lighten($color-warning, 42%));
      border: 1px solid $color-button-default-border;
      border-radius: $border-radius-small;
      position: relative;

      &:after {
        content: "+";
        position: absolute;
        right: 1.35rem;
        top: 50%;
        transform: translateY(-50%);
      }

      .hour-value {
        line-height: 1.5;
        margin-left: -1px;

        &.has-border {
          &:after {
            height: 80%;
          }
        }
      }

      .add-reservation {
        position: absolute;
        right: 1.35rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }
    }

    .hour-value {
      line-height: 1.6;
    }

    &.has-reservations {
      .hour-value {
        color: $color-notice;
      }
    }

    &.no-reservations {
      .hour-value {
        color: $color-text-light;
      }
    }
  }

  &.user-cannot-add {
    pointer-events: none;

    .calendar-item-wrapper.no-reservations {
      &:after {
        content: "";
      }
    }
  }

  &-reservations {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: calc(100% - 8.4rem);

    .ongoing-reservations {
      color: $color-text-light;
      font-size: 1rem;
      text-align: center;
      position: relative;
      top: -1px;
      width: 100%;

      .icon {
        margin-left: .5rem;
        position: relative;
        top: 3px;
      }
    }
  }

  .reservations-number + .ongoing-reservations {
    margin-top: -2.5px;
  }

  .button {
    margin-left: auto;
    margin-right: 0;
    will-change: transform;
  }

  .toggle-details {
    display: block;
    font-size: 1.1rem;
    padding: 1rem 0 .5rem 0;
    text-align: center;
  }

  &-content {
    display: none;
  }

  &.is-expanded {
    background: $color-bg-medium;
    border-radius: $border-radius-small;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .calendar-item-content {
      display: block;
    }

    .calendar-item-wrapper {
      & > .button {
        transform: rotate(-180deg);
      }
    }
  }

  &.is-grid {
    border-bottom: none;
    padding: 0;

    .calendar-item-content {
      display: block;

      /deep/ .reservation + .reservation {
        margin-top: 24px;
      }
    }

    &:first-child {
      border-top: none;
    }
  }

  &.is-list {
    .calendar-item-content {
      /deep/ .reservation {
        margin-top: 24px;
      }
    }
  }
}

@media (max-width: 1040px) {
  .calendar-item.is-expanded {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/CalendarItem.vue